<template>
	<div class="page">
		<youtube :video-id="videoId" :mute="mute" @ready="ready" @playing="playing" @ended="ended" @paused="paused" :controls="controls"></youtube>
		<transition name="fade" mode="out-in">
			<img v-if="mute" class="megaphone" src="/images/megaphone.png" @click="unmuteVideo"/>
		</transition>
		<div class="intro-copy-container">
			<transition name="bounce">
				<div v-if="bounce" class="intro-copy">
					{{name}},<br>
					let's start with a<br>
					<span>Bedtime<br>Rhyme</span>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { normalizePercentage } from '../helpers/audiofeatures.js';

export default {
	data() {
		return {
			playlistComplete: false,
			name: localStorage.getItem('name'),
			sleepstory: localStorage.getItem("sleepstory"),
			bounce: false,
			mute: true,
			controls: false,
			watchedFullVideo: false,
			watchSeconds: 0,
		}
	},
	computed: {
		videoId: function() {
			const mobile = this.$root.isMobile;
			if (this.sleepstory === '1') {
				return mobile ? 'MNA342L1KgY' : '_1SuTf7L89E';
			}
			else {
				return mobile ? 'MNA342L1KgY' : 'xucfS4RxhCo';
			}
		}
	},
	created() {
		this.generateGenreTracklist();
	},
	mounted() {
		this.bounce = true;
		setTimeout(() => {
			this.bounce = false;
		}, 5000)
	},
	beforeRouteLeave (to, from, next) {
		const amountWatched = this.watchedFullVideo ? 'Watched Full Video' : `Watched ${this.watchSeconds} seconds`;
		this.gaEvent('Bedtime Rhyme', amountWatched);
		console.log("WATCHED: ", amountWatched);
		
		next();
	},
	methods: {		
		ready (event) {
			this.player = event.target;
			this.player.playVideo();
		},
		playing (event) {
		// The player is playing a video.
			this.interval = setInterval(() => {
				this.watchSeconds = this.watchSeconds + 1;
			}, 1000)
		},
		paused (event) {
			clearInterval(this.interval);
		},
		ended (event) {
			this.watchedFullVideo = this.watchSeconds > 100 ? true : false
			this.$router.push({ name: 6 });
		},
		unmuteVideo() {
			this.gaEvent('Bedtime Rhyme', 'Clicked Sound On');
			this.mute = !this.mute;
		},
		async generateGenreTracklist() {

			const seedTrackList = {
				"hip-hop": [
					"3vZO25GdYuqFrR1kzZADnp",
					"6Nle9hKrkL1wQpwNfEkxjh",
					"285pBltuF7vW8TeWk8hdRR",
					"5LnXWeA9tuWKI2C1H74iiJ"
				],
				"pop": [
					"1VdZ0vKfR5jneCmWIUAMxK",
					"4HBZA5flZLE435QTztThqH",
					"3ZCTVFBt2Brf31RLEnCkWJ",
					"5p7ujcrUXASCNwRaWNHR1C"
				],
				"indie": [
					"0d6bZwEAi1XblGRhnzPfgC",
					"6UFivO2zqqPFPoQYsEMuCc",
					"28grzRrS5csyaI4uK98IX0",
					"6K4t31amVTZDgR3sKmwUJJ"
				],
				"dance": [
					"7jZHUhAmW5oq1cq6s8IxmK",
					"3WRQUvzRvBDr4AxMWhXc5E",
					"23FA91vzMAs3k0gMV3ZGaV",
					"1OStEtFJJ7xMbgQfp5C3j9"
				],
				"rock": [
					"0htjtrOVbQpWoDYYwPIrWY",
					"6qV3OEpN6uFCZnzNSslbn1",
					"5qqabIl2vWzo9ApSC317sa"
				],
			}

			const seekTrackList1 = [
				"30Zcjs7pgEkmJA1lEbGSWT",
				"0y9uTzK9cNKSAEHnpeRG8C", 
				"59S2fsj1QtJo99ocYo2PVB", 
				"0c6xIDDpzE81m2q797ordA",
				"30Zcjs7pgEkmJA1lEbGSWT"
			]
			const seekTrackList2 = [
				"5MGeW5mHnqeJiM0NPBbkEZ", 
				"0HOqINudNgQFpg1le5Hnqe", 
				"1NMYfyq8eE4qUCj2SXvrJd", 
				"4QqlfK1yqd8A4hykzkqSIA",
				"30Zcjs7pgEkmJA1lEbGSWT"
			]

			let seedGenres = JSON.parse(localStorage.getItem("seedGenres"));
			let seedTracks = [];
			for (let i = 0, len = seedGenres.length; i < 5 - len; i++) {
				seedTracks.push(seedTrackList[seedGenres[i % len]][Math.floor(i / len)]);
			}
			
			try {
				const limit = 15;
				let res = await axios.get('/spotify/tracklist/seeded', {
					params: {
						seed_genres: seedGenres,
						seet_tracks: seedTracks,
						target_energy: 0.1,
						target_valence: 0.1,
						limit
					}
				});

				const sleepstory = this.sleepstory;

				let spotifyTracks = res.data.tracks;
				let seekTracks = sleepstory === 1 ? seekTrackList1 : seekTrackList2;
				let tracks = [];
				for (let i = 0; i < limit; i++) {
					tracks.push(spotifyTracks[i].id);
					if (i % 3 == 0) {
						tracks.push(seekTracks[i / 3]);						
					}
				}
				localStorage.setItem('tracklist', JSON.stringify(tracks));
				
				localStorage.setItem('playlistName', sleepstory === "1" ? 'Get me outta this rut' : 'Gotta Shake Things Up');
				localStorage.setItem('playlistDescription',
					sleepstory === "1" 
					? "Break your career rut with a mix of advice from psychologist Sabina Read, delivered by Briggs, as well as music to help you relax." 
					: "Get a fresh take on your career with a mix of advice from psychologist Sabina Read, delivered by Briggs, as well as music to help you relax."
				);
				
				// console.log(tracks);
				
				this.$emit("allowForwards", true);
				
			} catch (err) {
				console.error(err);
				if (err.response) {
					console.error(err.response.data);
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
};
</script>

<style scoped>
.bounce-enter-active {
  	animation: bounce-in 0.5s;
}

.bounce-leave-active {
	animation: fade-out 2s;
}

@keyframes bounce-in {
    0% {
        opacity: 0;
        transform: scale(.3);
        height: 0rem;
    }
    20% {
        height: 4rem;
    }
    50% {
        opacity: 1;
        transform: scale(1.05)
    }
    70% {
        transform: scale(.9)
    }
    100% {
        transform: scale(1)
    }
}

@keyframes fade-out {
    from {opacity: 1; visibility: visible}
    to {opacity: 0; visibility: hidden}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}
.fade-enter, .fade-leave {
	opacity: 0;
}

.page {
	display: flex;
    align-items: center;
    justify-content: center;
}

.megaphone {
	z-index: 1;
	position: absolute;
	cursor: pointer;
    width: 16rem;
	transform: translateY(10rem);
	animation: megaphonefade 1s 5s forwards;

}
@keyframes megaphonefade {
    from {opacity: 1; visibility: visible}
    to {opacity: 0; visibility: hidden}
}

.page-inner {
	height: 100vh;
}

.title-overlay {
	position: absolute;
    z-index: 1;
    font-size: 4rem;
}

.embed-container {
	position: relative;
	padding-bottom: 70vh;
	height: 0;
	overflow: hidden;
	max-width: 100%;
}
.mobile .embed-container {
	padding-bottom: 30vh;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.intro-copy {
	position: absolute;
    font-size: 2.5rem;
    font-family: 'Seek Regular';
	text-align: center;
}

.intro-copy-container {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.intro-copy span {
	font-size: 5rem;
	font-family: 'Seek Regular';
}
</style>